import { render, staticRenderFns } from "./table-header.vue?vue&type=template&id=40b54324&"
import script from "./table-header.vue?vue&type=script&lang=ts&"
export * from "./table-header.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports